var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tabler / Arrows / Logout"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Style",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.38161 18.9336C9.47665 20.574 10.8371 21.875 12.5013 21.875H19.793L19.9766 21.8697C21.617 21.7746 22.918 20.4143 22.918 18.75L22.918 6.25L22.9127 6.06638C22.8176 4.42596 21.4572 3.125 19.793 3.125H12.5013L12.3177 3.13031C10.6773 3.22535 9.3763 4.58575 9.3763 6.25V8.33333L9.38331 8.45481C9.44348 8.97288 9.88376 9.375 10.418 9.375C10.9933 9.375 11.4596 8.90863 11.4596 8.33333V6.25L11.4666 6.12852C11.5268 5.61046 11.9671 5.20833 12.5013 5.20833H19.793L19.9144 5.21534C20.4325 5.27551 20.8346 5.7158 20.8346 6.25V18.75L20.8276 18.8715C20.7675 19.3895 20.3272 19.7917 19.793 19.7917H12.5013L12.3798 19.7847C11.8618 19.7245 11.4596 19.2842 11.4596 18.75V16.6667L11.4526 16.5452C11.3925 16.0271 10.9522 15.625 10.418 15.625C9.84267 15.625 9.3763 16.0914 9.3763 16.6667V18.75L9.38161 18.9336ZM5.51473 16.3616L5.61287 16.4482L5.71859 16.5204C6.11848 16.7587 6.64366 16.7058 6.98787 16.3616L7.07453 16.2634C7.39226 15.8548 7.36338 15.2639 6.98787 14.8884L5.64193 13.5417L17.7096 13.5417L17.8311 13.5347C18.3492 13.4745 18.7513 13.0342 18.7513 12.5C18.7513 11.9247 18.2849 11.4583 17.7096 11.4583L5.64297 11.4583L6.98787 10.1116L7.07453 10.0134C7.39226 9.6048 7.36338 9.01394 6.98787 8.63843C6.58108 8.23164 5.92153 8.23164 5.51473 8.63843L2.43222 11.7199C2.32402 11.8175 2.23809 11.9367 2.17832 12.0676L2.1361 12.1759L2.0981 12.328C2.04427 12.6377 2.12749 12.9743 2.38973 13.2366L5.51473 16.3616Z",
    fill: "#E01616"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.46bcb14d278156c55ba0a97029278cfb.svg";
export { ForwardRef as ReactComponent };